export default __webpack_public_path__ + "static/media/c.2f52df38.svg";